export default function initHeroHp() {
    let appliedPaddingTop = null;

    function updatePadding() {
        const container = document.querySelector('.hp-hero__foreground__container');
        if (!container) return;

        const isDesktop = window.innerWidth > 1024;

        if (!isDesktop) {
            if (appliedPaddingTop !== '') {
                container.style.paddingTop = '';
                appliedPaddingTop = '';
            }
            return;
        }

        const foreground = document.querySelector('.hp-hero__foreground');
        if (!foreground) return;

        const childHeight = foreground.offsetHeight;
        const foregroundTop = parseFloat(window.getComputedStyle(foreground).top);
        const newPaddingTop = childHeight + foregroundTop;

        if (newPaddingTop === appliedPaddingTop) return;

        const scrollX = window.scrollX;
        const scrollY = window.scrollY;

        container.style.paddingTop = `${newPaddingTop}px`;
        appliedPaddingTop = newPaddingTop;

        if (scrollY > 0) {
            window.scrollTo(scrollX, scrollY);
        }
    }

    window.addEventListener('resize', updatePadding);
    window.addEventListener('load', updatePadding);

    updatePadding();
}
